// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../reason/next/Next.bs.js");
var React = require("react");
var IconV5 = require("../uikit/atoms/Icon/IconV5.bs.js");
var Tooltip = require("../reason/common/Tooltip.bs.js");
var Intercom = require("../reason/common/Intercom.bs.js");
var AuthSession = require("../utils/AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RelayRuntime = require("relay-runtime");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var AlertsDropdownItem = require("./AlertsDropdownItem.bs.js");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var ReactAriaComponents = require("react-aria-components");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var AnimatedNotificationCount = require("./NotificationAlert/AnimatedNotificationCount.bs.js");
var RequireAuthenticatedAgent = require("../hoc/RequireAuthenticatedAgent.bs.js");
var AlertsDropdownQuery_graphql = require("../__generated__/AlertsDropdownQuery_graphql.bs.js");
var RescriptRelay_Subscriptions = require("rescript-relay/src/RescriptRelay_Subscriptions.bs.js");
var AlertsDropdown_query_graphql = require("../__generated__/AlertsDropdown_query_graphql.bs.js");
var AlertsDropdownAlertsSection_alerts_graphql = require("../__generated__/AlertsDropdownAlertsSection_alerts_graphql.bs.js");
var AlertsDropdownDismissAlertMutation_graphql = require("../__generated__/AlertsDropdownDismissAlertMutation_graphql.bs.js");
var AlertsDropdownNewAlertsSubscription_graphql = require("../__generated__/AlertsDropdownNewAlertsSubscription_graphql.bs.js");
var AlertsDropdownDismissAlertGroupMutation_graphql = require("../__generated__/AlertsDropdownDismissAlertGroupMutation_graphql.bs.js");

var noAlertsView = JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(IconV5.make, {
              icon: "no-alerts-bell",
              className: "mb-6 text-[60px] sm:mb-2.5 sm:text-2xl"
            }),
        JsxRuntime.jsx("span", {
              children: "You don't have any alerts"
            })
      ],
      className: "w-full h-full flex flex-col items-center justify-center text-base uppercase text-zinc-500 bg-white sm:text-[13px] sm:px-5 sm:py-2.5"
    });

var alertsListConnectionId = AlertsDropdown_query_graphql.makeConnectionId(RelayRuntime.ROOT_ID);

var convertVariables = AlertsDropdownDismissAlertGroupMutation_graphql.Internal.convertVariables;

var convertResponse = AlertsDropdownDismissAlertGroupMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = AlertsDropdownDismissAlertGroupMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, AlertsDropdownDismissAlertGroupMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, AlertsDropdownDismissAlertGroupMutation_graphql.node, convertResponse, convertWrapRawResponse);

var DismissAlertGroupMutation_alertGroup_decode = AlertsDropdownDismissAlertGroupMutation_graphql.Utils.alertGroup_decode;

var DismissAlertGroupMutation_alertGroup_fromString = AlertsDropdownDismissAlertGroupMutation_graphql.Utils.alertGroup_fromString;

var DismissAlertGroupMutation = {
  alertGroup_decode: DismissAlertGroupMutation_alertGroup_decode,
  alertGroup_fromString: DismissAlertGroupMutation_alertGroup_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

var convertVariables$1 = AlertsDropdownDismissAlertMutation_graphql.Internal.convertVariables;

var convertResponse$1 = AlertsDropdownDismissAlertMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = AlertsDropdownDismissAlertMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, AlertsDropdownDismissAlertMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, AlertsDropdownDismissAlertMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var DismissAlertMutation_alertGroup_decode = AlertsDropdownDismissAlertMutation_graphql.Utils.alertGroup_decode;

var DismissAlertMutation_alertGroup_fromString = AlertsDropdownDismissAlertMutation_graphql.Utils.alertGroup_fromString;

var DismissAlertMutation_alertStatus_decode = AlertsDropdownDismissAlertMutation_graphql.Utils.alertStatus_decode;

var DismissAlertMutation_alertStatus_fromString = AlertsDropdownDismissAlertMutation_graphql.Utils.alertStatus_fromString;

var DismissAlertMutation = {
  alertGroup_decode: DismissAlertMutation_alertGroup_decode,
  alertGroup_fromString: DismissAlertMutation_alertGroup_fromString,
  alertStatus_decode: DismissAlertMutation_alertStatus_decode,
  alertStatus_fromString: DismissAlertMutation_alertStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$1
};

var convertFragment = AlertsDropdownAlertsSection_alerts_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AlertsDropdownAlertsSection_alerts_graphql.node, convertFragment, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(AlertsDropdownAlertsSection_alerts_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(fRef) : undefined, AlertsDropdownAlertsSection_alerts_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AlertsDropdownAlertsSection_alerts_graphql.node, convertFragment, fRef);
}

var AlertsFragment_alertGroup_decode = AlertsDropdownAlertsSection_alerts_graphql.Utils.alertGroup_decode;

var AlertsFragment_alertGroup_fromString = AlertsDropdownAlertsSection_alerts_graphql.Utils.alertGroup_fromString;

var AlertsFragment = {
  alertGroup_decode: AlertsFragment_alertGroup_decode,
  alertGroup_fromString: AlertsFragment_alertGroup_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$2,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function AlertsDropdown$AlertsSection(props) {
  var onDismiss = props.onDismiss;
  var group = props.group;
  var alerts = use$2(props.filteredAlerts);
  var match = use();
  var isDismissingAlertGroup = match[1];
  var dismissAlertGroup = match[0];
  var isImpersonated = AuthSession.useIsImpersonated();
  var tmp;
  tmp = group === "CONVERSATIONS" ? "Conversations" : "Match";
  var dismissAlertGroupLink = JsxRuntime.jsx("a", {
        children: JsxRuntime.jsx(IconV5.make, {
              icon: "cancel"
            }),
        className: "text-zinc-500 no-underline hover:text-zinc-700",
        href: "#",
        onClick: (function (e) {
            e.preventDefault();
            if (!isImpersonated && !isDismissingAlertGroup) {
              dismissAlertGroup({
                    connections: [alertsListConnectionId],
                    input: {
                      group: group
                    }
                  }, undefined, {
                    dismissAlertsByGroupV5: {
                      __typename: "AlertsGroupDismissed",
                      __typename: "AlertsGroupDismissed",
                      deletedAlertNodeIds: alerts.map(function (alert) {
                            return alert.nodeId;
                          })
                    }
                  }, undefined, undefined, undefined, undefined);
              return ;
            }
            
          })
      });
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("h4", {
                      children: [
                        tmp,
                        isImpersonated ? JsxRuntime.jsx(Tooltip.make, {
                                label: "You cannot dismiss alerts when you are impersonated.",
                                children: dismissAlertGroupLink
                              }) : dismissAlertGroupLink
                      ],
                      className: "flex items-center justify-between bg-zinc-200 text-zinc-700 px-4 py-3 font-semibold uppercase"
                    }),
                JsxRuntime.jsx("div", {
                      children: alerts.map(function (v) {
                            return JsxRuntime.jsx(AlertsDropdownItem.make, {
                                        alert: v.fragmentRefs,
                                        onDismiss: (function () {
                                            onDismiss(v.id);
                                          })
                                      }, v.id);
                          }),
                      className: "divide-y divide-gray-200"
                    })
              ],
              className: ""
            });
}

var AlertsSection = {
  AlertsFragment: AlertsFragment,
  make: AlertsDropdown$AlertsSection
};

var convertVariables$2 = AlertsDropdownQuery_graphql.Internal.convertVariables;

var convertResponse$2 = AlertsDropdownQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse$2 = AlertsDropdownQuery_graphql.Internal.convertWrapRawResponse;

var use$3 = RescriptRelay_Query.useQuery(convertVariables$2, AlertsDropdownQuery_graphql.node, convertResponse$2);

var useLoader = RescriptRelay_Query.useLoader(convertVariables$2, AlertsDropdownQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(AlertsDropdownQuery_graphql.node, convertResponse$2, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(AlertsDropdownQuery_graphql.node, convertResponse$2, convertVariables$2);

var fetchPromised = RescriptRelay_Query.fetchPromised(AlertsDropdownQuery_graphql.node, convertResponse$2, convertVariables$2);

var retain = RescriptRelay_Query.retain(AlertsDropdownQuery_graphql.node, convertVariables$2);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  use: use$3,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

var convertFragment$1 = AlertsDropdown_query_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AlertsDropdown_query_graphql.node, convertFragment$1, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(AlertsDropdown_query_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AlertsDropdown_query_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(AlertsDropdown_query_graphql.node, convertFragment$1, fRef);
}

var QueryFragment_getConnectionNodes = AlertsDropdown_query_graphql.Utils.getConnectionNodes;

var QueryFragment_alertGroup_decode = AlertsDropdown_query_graphql.Utils.alertGroup_decode;

var QueryFragment_alertGroup_fromString = AlertsDropdown_query_graphql.Utils.alertGroup_fromString;

var QueryFragment_alertStatus_decode = AlertsDropdown_query_graphql.Utils.alertStatus_decode;

var QueryFragment_alertStatus_fromString = AlertsDropdown_query_graphql.Utils.alertStatus_fromString;

var QueryFragment = {
  getConnectionNodes: QueryFragment_getConnectionNodes,
  alertGroup_decode: QueryFragment_alertGroup_decode,
  alertGroup_fromString: QueryFragment_alertGroup_fromString,
  alertStatus_decode: QueryFragment_alertStatus_decode,
  alertStatus_fromString: QueryFragment_alertStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$4,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

var convertVariables$3 = AlertsDropdownNewAlertsSubscription_graphql.Internal.convertVariables;

var convertResponse$3 = AlertsDropdownNewAlertsSubscription_graphql.Internal.convertResponse;

var subscribe = RescriptRelay_Subscriptions.subscribe(AlertsDropdownNewAlertsSubscription_graphql.node, convertVariables$3, convertResponse$3);

var Subscription_alertGroup_decode = AlertsDropdownNewAlertsSubscription_graphql.Utils.alertGroup_decode;

var Subscription_alertGroup_fromString = AlertsDropdownNewAlertsSubscription_graphql.Utils.alertGroup_fromString;

var Subscription = {
  alertGroup_decode: Subscription_alertGroup_decode,
  alertGroup_fromString: Subscription_alertGroup_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$3,
  convertResponse: convertResponse$3,
  subscribe: subscribe
};

function AlertsDropdown$Dropdown(props) {
  var query = use$3(undefined, undefined, undefined, undefined);
  var data = use$4(query.fragmentRefs);
  var match = use$1();
  var dismissAlert = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setIsOpened = match$1[1];
  var isOpened = match$1[0];
  var router = Next.useRouter();
  var environment = RescriptRelay.useEnvironmentFromContext();
  React.useEffect((function () {
          var subscription = subscribe(environment, {
                connections: [alertsListConnectionId]
              }, undefined, undefined, undefined, undefined);
          return (function () {
                    subscription.dispose();
                  });
        }), []);
  React.useEffect((function () {
          setIsOpened(function (param) {
                return false;
              });
        }), [Next.Router.asPath(router)]);
  var alerts = Core__Option.getOr(Core__Option.map(data.alertsForCurrentUser, (function (v) {
              return Core__Array.keepSome(v.edges).map(function (e) {
                            return e.node;
                          }).filter(function (alert) {
                          return alert.status === "NEW";
                        });
            })), []);
  var conversationAlerts = alerts.filter(function (alert) {
          return alert.grouping === "CONVERSATIONS";
        }).map(function (v) {
        return v.fragmentRefs;
      });
  var matchAlerts = alerts.filter(function (alert) {
          return alert.grouping === "MATCHES";
        }).map(function (v) {
        return v.fragmentRefs;
      });
  var isEmpty = alerts.length === 0;
  var onDismiss = function (id) {
    dismissAlert({
          connections: [alertsListConnectionId],
          input: {
            id: id
          }
        }, undefined, undefined, undefined, undefined, undefined, undefined);
  };
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs(ReactAriaComponents.DialogTrigger, {
                          children: [
                            JsxRuntime.jsxs(ReactAriaComponents.Button, {
                                  children: [
                                    JsxRuntime.jsx(IconV5.make, {
                                          icon: isOpened ? "bell-filled" : "bell",
                                          size: 22
                                        }),
                                    JsxRuntime.jsx(AnimatedNotificationCount.make, {
                                          count: alerts.length,
                                          isOpened: isOpened
                                        })
                                  ],
                                  className: (function (param) {
                                      return TailwindMerge.twMerge([
                                                  "flex w-6 border-none p-0 bg-none text-[22px] relative cursor-pointer sm:text-zinc-500",
                                                  "z-20 text-zinc-500"
                                                ]);
                                    }),
                                  isDisabled: isEmpty
                                }),
                            innerWidth < 545 ? JsxRuntime.jsx(ReactAriaComponents.ModalOverlay, {
                                    children: JsxRuntime.jsx(ReactAriaComponents.Modal, {
                                          children: JsxRuntime.jsx(ReactAriaComponents.Dialog, {
                                                children: isEmpty ? noAlertsView : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                        children: [
                                                          conversationAlerts.length > 0 ? JsxRuntime.jsx(AlertsDropdown$AlertsSection, {
                                                                  group: "CONVERSATIONS",
                                                                  filteredAlerts: conversationAlerts,
                                                                  onDismiss: onDismiss
                                                                }) : null,
                                                          matchAlerts.length > 0 ? JsxRuntime.jsx(AlertsDropdown$AlertsSection, {
                                                                  group: "MATCHES",
                                                                  filteredAlerts: matchAlerts,
                                                                  onDismiss: onDismiss
                                                                }) : null
                                                        ]
                                                      }),
                                                ariaLabel: "Alerts",
                                                className: "p-0 m-0 rounded-none"
                                              }),
                                          className: (function (param) {
                                              return TailwindMerge.twMerge([
                                                          "fixed inset-x-0 w-full rounded-none bg-white shadow-md overflow-auto p-0 m-0",
                                                          Intercom.isBannerVisible() ? "top-[100px] max-h-[calc(100vh-100px)]" : "top-[66px] max-h-[calc(100vh-66px)]"
                                                        ]);
                                            }),
                                          isDismissable: true
                                        }),
                                    isDismissable: true,
                                    className: (function (param) {
                                        return "z-[1000]";
                                      })
                                  }) : JsxRuntime.jsx(ReactAriaComponents.Popover, {
                                    children: JsxRuntime.jsx(ReactAriaComponents.Dialog, {
                                          children: isEmpty ? noAlertsView : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                  children: [
                                                    conversationAlerts.length > 0 ? JsxRuntime.jsx(AlertsDropdown$AlertsSection, {
                                                            group: "CONVERSATIONS",
                                                            filteredAlerts: conversationAlerts,
                                                            onDismiss: onDismiss
                                                          }) : null,
                                                    matchAlerts.length > 0 ? JsxRuntime.jsx(AlertsDropdown$AlertsSection, {
                                                            group: "MATCHES",
                                                            filteredAlerts: matchAlerts,
                                                            onDismiss: onDismiss
                                                          }) : null
                                                  ]
                                                }),
                                          ariaLabel: "Alerts",
                                          className: "p-0"
                                        }),
                                    className: TailwindMerge.twMerge([
                                          isEmpty ? "sm:right-0 sm:w-[234px] sm:-translate-x-[50%] sm:left-[11px]" : "sm:right-4 sm:w-[480px] sm:left-auto",
                                          "rounded-md bg-white shadow-md sm:max-h-[400px] overflow-auto z-[999]"
                                        ])
                                  })
                          ],
                          isOpen: isOpened,
                          onOpenChange: (function (newOpen) {
                              setIsOpened(function (param) {
                                    return newOpen;
                                  });
                            })
                        }),
                    className: TailwindMerge.twMerge([
                          "flex self-stretch relative items-center",
                          isOpened ? "before:w-0 before:h-0 before:border-style-solid before:border-t-0 before:border-r-[9px] before:border-b-[10px] before:border-l-[9px] before:border-transparent before:border-b-zinc-200 before:content-[''] before:absolute before:bottom-0 before:z-20 before:left-1 z-[2000]" : ""
                        ])
                  }),
              className: "flex self-stretch items-center"
            });
}

var Dropdown = {
  make: AlertsDropdown$Dropdown
};

function AlertsDropdown(props) {
  return JsxRuntime.jsx(React.Suspense, {
              children: Caml_option.some(JsxRuntime.jsx(RequireAuthenticatedAgent.make, {
                        children: JsxRuntime.jsx(AlertsDropdown$Dropdown, {}),
                        loaderComponent: Caml_option.some(null)
                      })),
              fallback: Caml_option.some(null)
            });
}

var make = AlertsDropdown;

exports.noAlertsView = noAlertsView;
exports.alertsListConnectionId = alertsListConnectionId;
exports.DismissAlertGroupMutation = DismissAlertGroupMutation;
exports.DismissAlertMutation = DismissAlertMutation;
exports.AlertsSection = AlertsSection;
exports.Query = Query;
exports.QueryFragment = QueryFragment;
exports.Subscription = Subscription;
exports.Dropdown = Dropdown;
exports.make = make;
/* noAlertsView Not a pure module */
